import getTableConversationRelation from 'mini-mail-list-store/lib/utils/getTableConversationRelation';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { trace } from 'owa-trace';

const shouldShowMailListItem = (itemId: string, tableView: TableView): boolean => {
    if (!tableView) {
        return false;
    }

    const listViewType = tableView.tableQuery.listViewType;

    switch (listViewType) {
        case ReactListViewType.Conversation:
            return doesTableConversationExistForItem(itemId, tableView);
        case ReactListViewType.Message:
            return doesItemExistInMailStore(itemId);

        default:
            trace.warn('shouldShowMailListItem: Not supported listViewType:' + listViewType);
            return false;
    }
};

const doesItemExistInMailStore = (itemId: string): boolean => {
    const item = getMailStore().items.get(itemId);

    return !!item;
};

const doesTableConversationExistForItem = (
    conversationId: string,
    tableView: TableView
): boolean => {
    const listViewStore = getListViewStore();
    const conversationItem = listViewStore.conversationItems.get(conversationId);

    if (tableView && conversationItem) {
        const tableConversationRelation = getTableConversationRelation(
            conversationItem.id,
            tableView.id
        );

        return !!tableConversationRelation;
    }

    return false;
};

export default shouldShowMailListItem;
